export default __webpack_public_path__ + "static/media/Sbarro.aa07dfe3.png";